import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import SpecialLinksComponent, { SpecialLinksButton }
  from '@fuww/library/src/Navigation/SpecialLinks';
import { Link } from '../../routes';

const specialLinksProperties = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      route: PropTypes.string,
      params: PropTypes.shape({}),
    }).isRequired,
  ),
};

type SpecialLinksProperties = InferProps<typeof specialLinksProperties>;

const SpecialLinks = ({ links }: SpecialLinksProperties) => (
  links && (
    <SpecialLinksComponent
      links={
        links.map(
          ({
            text,
            href,
            route,
            params,
          }) => (
            <Link
              key={href}
              route={route}
              href={href}
              params={params}
              passHref
            >
              <SpecialLinksButton>
                {text}
              </SpecialLinksButton>
            </Link>
          ),
        )
      }
    />
  )
);

SpecialLinks.propTypes = specialLinksProperties;

export default SpecialLinks;
